import { Paginator } from '@cast/design-system';

import { useSearchContext } from '@cast/shared-search-ui';

export type InfinitePaginatorProps = {
  pageSize: number;
};

export const InfinitePaginator = ({ pageSize }: InfinitePaginatorProps) => {
  const searchCtx = useSearchContext();
  const currentPage = searchCtx?.metadata?.currentPage;
  const hasNextPage = searchCtx?.metadata?.hasNextPage;
  const count =
    ((currentPage || 1) - 1) * pageSize +
    (searchCtx?.filteredData?.length || 0);

  const paginatorVisible =
    !searchCtx?.isLoading &&
    currentPage !== undefined &&
    pageSize !== undefined &&
    !!count;

  if (!paginatorVisible) {
    return null;
  }

  return (
    <Paginator
      infinite
      canGoForward={hasNextPage}
      recordsCount={count}
      pageSize={pageSize}
      currentPage={currentPage}
      onCurrentPageChange={(_, dir) => {
        if (dir === 'forward') {
          searchCtx?.fetchNextPage?.();
        }
        if (dir === 'back') {
          searchCtx?.fetchPreviousPage?.();
        }
      }}
    />
  );
};
